import { useCitiesContext } from '../../../context/CitiesContext';
import CityList from '../../CityList';
import { SEO_LINK_CITIES_KEYS } from '../../utils/seoConstants';

import './CityListContainer.scss';

const CityListContainer = () => {
  const { cities } = useCitiesContext();

  const listCities = cities
    .filter(city => SEO_LINK_CITIES_KEYS.includes(city.id))
    .sort((a, b) => a.cityName.localeCompare(b.cityName));

  return (
    <section className="city-list-container">
      <CityList
        cities={listCities}
        collapsible={false}
        titleKey={'top.cities.explore.title'}
      />
    </section>
  );
};

export default CityListContainer;
